import clsx from "clsx"
import ProductSelector from "components/EvtKit/ProductSelector"
import Button from "components/EvtKit/button/Button"
import Heading from "components/Typography/Heading"
import { memo, useCallback } from "react"
import { IoMdAddCircleOutline } from "react-icons/io"
import { changeModalState } from "reducers/event-types/event-types-actions"
import { useAppDispatch } from "reducers/store"
import styled from "styled-components"
import { Colors } from "themes/palette"
import Board from "./Board"

const ContainerTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`

const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  padding: 24px 0;
`
const ProductContainer = styled.div`
  display: flex;
  width: 320px;
`

const ButtonCustom = styled(Button)`
  width: 330px;
  margin-right: 24px;
`

interface Props {
  hasData: boolean
  filterValue: string
  setFilterValue: (value: string) => void
}

const EventTypesHeader = (props: Props) => {
  const { hasData, filterValue, setFilterValue } = props
  const appDispatch = useAppDispatch()

  const handleSelectChange = useCallback((productValue) => {
    setFilterValue(productValue)
  }, [])

  const openCreateModal = useCallback(() => {
    appDispatch(changeModalState(true, "create"))
  }, [])

  return (
    <>
      <ContainerTitle>
        <Heading variant="h3">Tipos de Eventos</Heading>
        {hasData && (
          <ButtonCustom
            onClick={openCreateModal}
            iconLeft={<IoMdAddCircleOutline size={24} color={Colors.white} />}
            label="Criar novo Tipo de Evento"
            className={clsx("background-gradient")}
          />
        )}
      </ContainerTitle>
      <SelectContainer>
        <ProductContainer>
          <ProductSelector onChange={handleSelectChange} value={filterValue} label="Filtrar por produto" cleanFilter />
        </ProductContainer>
      </SelectContainer>
      {!hasData && <Board openCreateModal={openCreateModal} filterValue={filterValue} />}
    </>
  )
}

export default memo(EventTypesHeader)
